export default __webpack_public_path__ + "locales/fr/PDFFormDialog.json?hash=402e6d64c108b4bcb49e2476a46db87e";